import * as Const from '../conts';

const ActualizarCarrito = (carrito) => {
    return {
        type: Const.SET_CARRITO,
        payload: carrito
    }
}

export default ActualizarCarrito;